import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaCheckCircle } from 'react-icons/fa';

const UrbaniaBusSection = () => {
  const features = [
    {
      title: 'Modern Comfort',
      description: 'Both the 13-seater and 17-seater Urbania buses are designed with modern comfort in mind.'
    },
    {
      title: 'Air Conditioning',
      description: 'The air conditioning system ensures that passengers remain cool and comfortable, regardless of external weather conditions.'
    },
    {
      title: 'Entertainment',
      description: 'Urbania buses are equipped with advanced audio systems that enhance the travel experience.'
    },
    {
      title: 'Convenience',
      description: 'Urbania buses offer convenient features like storage compartments for personal belongings.'
    }
  ];

  return (
    <section style={{ backgroundColor: '#F9FEFF', padding: '60px 20px' }}>
      <div className="container">
        <div className="row align-items-center">
          
          {/* Image Section */}
          <div className="col-md-6 mb-4 mb-md-0 text-center">
            <img
              src="/images/service/services1.jpg" 
              alt="Urbania Bus"
              className="img-fluid rounded shadow-sm"
              style={{ maxHeight: '400px', objectFit: 'cover' }}
            />
          </div>

          {/* Text Section */}
          <div className="col-md-6">
            <h2 className="fw-bold mb-3">Urbania Bus 13 & 17 Seater</h2>
            <p className="text-muted">
              The 13-seater Urbania bus is perfect for smaller groups who desire comfort and convenience without the bulk of larger vehicles. 
              This compact yet spacious bus is ideal for city tours, short trips, and small corporate outings.
            </p>

            <div className="bg-white p-4 rounded shadow-sm">
              <h5 className="fw-bold mb-3">Features and Benefits</h5>
              <ul className="list-unstyled">
                {features.map((item, idx) => (
                  <li key={idx} className="d-flex align-items-start mb-3">
                    <FaCheckCircle className="text-success me-2 mt-1" />
                    <div>
                      <strong>{item.title}:</strong> {item.description}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default UrbaniaBusSection;
